"use client"

import { useQuery } from "@tanstack/react-query"

import { UserProfile } from "@lib/clients/nelo-api-client"
import { neloApiClient } from "@lib/config-client"

export const useGetProfile = (enabled = true) => {
  const { data: profile, ...props } = useQuery<UserProfile>({
    queryKey: ["userProfile"],
    queryFn: () => neloApiClient.getUserProfile(),
    enabled: enabled,
  })

  return {
    profile,
    ...props,
  }
}
